import React from 'react'
import { t } from 'ttag'

import { ActionsDropdown } from 'components/shared/ActionsDropdown/ActionsDropdown'
import { ActionsCell } from 'components/shared/Table/common/Cells/ActionsCell/ActionsCell'
import { HeaderCell } from 'components/shared/Table/common/Cells/HeaderCell/HeaderCell'
import { PrimaryCell } from 'components/shared/Table/common/Cells/PrimaryCell/PrimaryCell'
import { TextCell } from 'components/shared/Table/common/Cells/TextCell/TextCell'
import { Pagination } from 'components/shared/Table/common/Pagination/Pagination'
import { toTemplates } from 'ducks/router'
import { Table } from 'components/shared/Table/Table'

import { getCommaSeparatedText } from 'components/pages/Templates/helpers'
import { getLanguageSymbol } from 'utils/languages'
import { getActions } from './helpers'
import { useInterviewsTable } from './hooks'

const mapSortingPropToQueryParam = {
  name: 'title',
}

export const InterviewsTable = ({
  search,
  handleCopy,
  handleDelete,
  handleEdit,
  filter,
}) => {
  const { state, handlers } = useInterviewsTable({
    mapSortingPropToQueryParam,
    search,
    filter,
  })

  const {
    pagination: { currentPage, pageCount, perPage },
    table: { headers, model, rowActions, isFetching },
  } = state
  const {
    pagination: { handlePage, handlePageSize },
  } = handlers

  return (
    <>
      <Table>
        <Table.Head>
          <Table.Row type="head">
            {headers.map(
              ({ columnDef, getToggleSortingHandler, getIsSorted }) => {
                const { accessorKey, header, alignLeft } = columnDef

                return (
                  <HeaderCell
                    key={header}
                    alignLeft={!!alignLeft}
                    sortType={getIsSorted()}
                    text={header}
                    onClick={getToggleSortingHandler()}
                    hasSorting={accessorKey}
                  />
                )
              },
            )}
          </Table.Row>
        </Table.Head>
        <Table.Body
          placeholder={{
            title: t`No interview templates yet`,
            text: t`Click “+ Interview template“ to add`,
          }}
          isLoaded={!isFetching}
        >
          {model.rows.map(({ id, original }) => {
            const {
              language,
              projects,
              project_templates,
              title,
              writeable,
              department,
            } = original

            const symbol = getLanguageSymbol(language)
            const actions = getActions(
              { actions: rowActions, id, title, writeable },
              { handleCopy, handleDelete, handleEdit },
            )

            return (
              <Table.Row key={id} type="body">
                <PrimaryCell
                  primary={title}
                  hasIncreasedHeight
                  maxWidth="12rem"
                  to={toTemplates('interviews', id)}
                />
                <TextCell text={department?.name} />
                <TextCell text={symbol} hasIncreasedHeight />
                <TextCell
                  text={getCommaSeparatedText(projects)}
                  maxWidth="6rem"
                  hasIncreasedHeight
                />
                <TextCell
                  text={getCommaSeparatedText(project_templates)}
                  maxWidth="6rem"
                  hasIncreasedHeight
                />
                <ActionsCell>
                  <ActionsDropdown size="medium" {...{ actions }} />
                </ActionsCell>
              </Table.Row>
            )
          })}
        </Table.Body>
      </Table>
      <Pagination
        onSetPage={handlePage}
        onSetPageSize={handlePageSize}
        {...{ currentPage, pageCount, perPage }}
      />
    </>
  )
}
